import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const markAllRead = async () => {
  const { data } = await axiosInstance.post('/notifications/mark_all_read/');
  return data;
};

export const useMarkAllRead = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: markAllRead,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { markAllRead: mutation.mutateAsync, ...mutation };
};
